<div class="d-flex" id="wrapper">
  <admin-sidebar id="admin-sidebar"></admin-sidebar>
  <div id="page-content-wrapper">
    <admin-navigation></admin-navigation>
    <div class="container-fluid">
      <div class="mt-5 mt-md-5 mb-3 mb-md-3">
        <h3 class="font-weight-bold page-title">Billing History</h3>
      </div>
    <div>
  </div>
  <div class="row mb-4 mb-md-4">
    <div class="form-group col-md-2">
      <div class="input-group">
        <input
          class="form-control"
          placeholder="Date from"
          name="fromDate"
          ngbDatepicker
          (click)="d.toggle()"
          (dateSelect)="onDateFromSelection($event)"
          #d="ngbDatepicker"
          id="dateInputFrom"
          [(ngModel)]="dpFromDate"
          readonly
        >
        <div class="input-group-append clear-date">
          <span class="input-group-text" (click)="clearDateFrom()"><i class="fa fa-times"></i> </span>
        </div>
      </div>
    </div>

    <div class="form-group col-md-2">
      <div class="input-group">
        <input
          class="form-control"
          placeholder="Date to"
          name="toDate"
          ngbDatepicker
          (click)="f.toggle()"
          (dateSelect)="onDateToSelection($event)"
          #f="ngbDatepicker"
          id="dateInputTo"
          [(ngModel)]="dpToDate"
          readonly
        >
        <div class="input-group-append clear-date">
          <span class="input-group-text" (click)="clearDateTo()"><i class="fa fa-times"></i> </span>
        </div>
      </div>
    </div>
    <div class="col-md-2 pl-3 pl-md-3">
      <input type="text" class="form-control" placeholder="Search Name" id="searchBillingInput">
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 table-responsive">
      <table class="table table-borderless">
        <colgroup>
          <col width="25%">
          <col width="25%">
          <col width="25%">
          <col width="25%">
        </colgroup>
        <thead>
          <tr>
            <th class="text-left">Date</th>
            <th class="text-left">Order By</th>
            <th class="text-left">Type</th>
            <th class="text-right">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of billings | paginate:{itemsPerPage: 25, currentPage:p}">
            <td>{{item.created * 1000 | date:'dd/MM/yyyy':'+1200'}}</td>
            <td>{{item.first_name}} {{item.last_name}}</td>
            <td>{{ item.type == "subscription" ? "Take a Breath Subscription" : "Breathing Device" }}</td>
            <td class="text-right">${{item.amount}}</td>
          </tr>
          <tr *ngIf="!loading && billings?.length == 0 && processingSearch == 0">
            <td class="align-middle text-center" colspan="4">No Record Found</td>
          </tr>
        </tbody>
      </table>

      <!-- Pagination -->
      <nav *ngIf="!loading && billings?.length > 0">
        <ul class="pagination justify-content-center">
          <li
            class="page-item"
            [ngClass]="{'disabled': currentPage == 1}"
            (click)="paginate(currentPage - 1)"
          >
            <a class="page-link" tabindex="-1">Previous</a>
          </li>
          <li
            class="page-item"
            *ngFor="let link of pageLinks"
            [ngClass]="{'active': currentPage == link}"
            (click)="paginate(link)"
          >
            <a class="page-link">{{ link }} <span class="sr-only" *ngIf="currentPage == link">(current)</span></a>
          </li>
          <li
            class="page-item"
            [ngClass]="{'disabled': currentPage == lastPage}"
            (click)="paginate(currentPage + 1)"
          >
            <a class="page-link">Next</a>
          </li>
        </ul>
      </nav>
      <!-- End of Pagination -->
    </div>
  </div>

  <!-- Modal Loader -->
  <modal-loader [modalText]="modalText"></modal-loader>

</div>
</div>
</div>
